if (!customElements.get("custom-reviews-slider")) {
  customElements.define(
    "custom-reviews-slider",
    class CustomReviewsSlider extends HTMLElement {
      constructor() {
        super();
        this.mainSliderRef = this.querySelector("[data-main-slider]");
        this.thumbSliderRef = this.querySelector("[data-thumb-slider]");
        this.nextRef = this.querySelector('[data-navigation="next"]') || null;
        this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
        this.paginationRef = this.querySelector("[data-pagination]") || null;
        this.initSlider = this.initSlider.bind(this);
      }

      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        this.thumbSwiper = new Swiper(this.thumbSliderRef, {
          spaceBetween: 0,
          slidesPerView: 1,
          grabCursor: true,
        });
        
        this.mainSwiper = new Swiper(this.mainSliderRef, {
          grabCursor: true,
          loop: false,
          autoplay: false,
          slidesPerView: 1,
          spaceBetween: 0,

          keyboard: {
            enabled: true,
          },
          pagination: {
            el: this.paginationRef,
            clickable: true,
          },
          navigation: {
            nextEl: this.nextRef,
            prevEl: this.previousRef,
          },
          thumbs: {
            swiper: this.thumbSwiper,
          },
        });
      }

      disconnectedCallback() {
        this.thumbSwiper.destroy();
        this.mainSwiper.destroy();
      }
    }
  );
}
